import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

type TodaysEscapesScheduleGenerationPostContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/todays-escapes-schedule/schedules']['post'];

export type TodaysEscapesScheduleGenerationSegment = NonNullable<
  TodaysEscapesScheduleGenerationPostContract['parameters']['query']['segment']
>;

export interface TodaysEscapesScheduleGenerationParams {
  brand: string;
  countryGroup: string;
  /**
   * YYYY-MM-DD
   */
  sendDate: string;
  /** Lifestyle brands generate their travel and experience sends separately, so they must pass one */
  segment?: TodaysEscapesScheduleGenerationSegment;
}

/**
 * Queues tail deal generation for every country in the country group. Existing schedules for the send date are marked
 * as regenerating straight away, and stay unavailable to the send until the queued jobs finish.
 */
async function requestPostTodaysEscapesScheduleGeneration({
  brand,
  countryGroup,
  sendDate,
  segment,
}: TodaysEscapesScheduleGenerationParams): Promise<string> {
  const url = makeCustomerCommunicationV1URL('/todays-escapes-schedule/schedules');
  url.searchParams.set('brand', brand);
  url.searchParams.set('countryGroup', countryGroup);
  url.searchParams.set('sendDate', sendDate);
  if (segment) {
    url.searchParams.set('segment', segment);
  }

  const response: TodaysEscapesScheduleGenerationPostContract['responses']['200']['content']['application/json'] =
    await request(url.toString(), {
      method: 'POST',
      credentials: 'include',
    });

  return response.message;
}

export default requestPostTodaysEscapesScheduleGeneration;
